<template>
    <div>
        <h3>パスワード・メールアドレス変更</h3>
        <div>
            <h4>メールアドレス変更</h4>
            <p>
                パスワードログインが設定されているユーザーは、メールアドレスを変更できます。
                メールアドレスを変更した場合、新たに設定されたメールアドレスに確認メールが送信されます。
                承認が行われるまで、メールアドレスは未承認の状態になります。
            </p>
            <p>
                連携ログインのみ設定しているユーザーは、メールアドレスを変更できません。
                先にパスワードログインの設定を行ってからメールアドレスの変更を行ってください。
            </p>
            <h4>パスワード変更</h4>
            <p>
                パスワード変更時は、現在設定されているパスワードが必要になります。
                連携ログインのみ設定されているユーザーの場合、現在のパスワードは空欄にしてください。
            </p>
            <h4>メールアドレスを外部サービスと連携する</h4>
            <p>
                パスワードログインが設定されたメールアドレスが、Googleアカウントで使用しているものと同一の場合、
                連携ログインを設定することができます。
            </p>
            <p>
                連携ログインボタンを押して、適切なメールアドレスの登録が確認されれば、連携が完了します。
                連携していない状態で、連携ログインを行おうとしても、ログインすることはできません。
            </p>
        </div>
    </div>
</template>

<style src="../help.scss" scoped lang="scss"></style>

<script>
export default {
    created() {
        this.useHead({
            title: "パスワード・メールアドレス変更 | 貸し本棚ヘルプ",
            link: [
                {
                    rel: "canonical",
                    href: location.origin + location.pathname,
                    id: "canonical"
                }
            ]
        });
    }
}
</script>